import {VStack} from '@chakra-ui/react';
import {imageOptimisee, placeholderImage} from './optimisation';
import {useVignetteArticle} from 'ff-common';
import {Navigable} from '@synako/halitrek';
import {ArticleDesc} from 'api-types/ffconnect-hal';

export const VignetteArticleVStack: React.FC<{
  article: Navigable<ArticleDesc> | undefined;
  boxSize?: string;
}> = ({article, boxSize}) => {
  if (!article) {
    return (
      <InnerVignetteArticleVStack
        imageUrl={placeholderImage}
        boxSize={boxSize}
      />
    );
  }
  return (
    <RealVignetteArticleVStack
      article={article}
      boxSize={boxSize}
    />
  );
};

export const RealVignetteArticleVStack: React.FC<{
  article: Navigable<ArticleDesc>;
  boxSize?: string;
}> = ({article, ...imgProps}) => {
  const img = useVignetteArticle(article);
  const imageUrl = imageOptimisee(img ?? placeholderImage, 85);
  return (
    <InnerVignetteArticleVStack
      imageUrl={imageUrl}
      {...imgProps}
    />
  );
};

export const InnerVignetteArticleVStack: React.FC<{
  imageUrl: string;
  boxSize?: string;
}> = ({imageUrl, boxSize = '85px'}) => {
  return (
    <VStack
      justifyContent='center'
      bg='transparent'
      minH={boxSize}
      minW={boxSize}
      h='100%'
      alignSelf='stretch'
      bgImage={imageUrl}
      bgPos='top center'
      bgSize='contain'
      bgRepeat='no-repeat'
    />
  );
};
